import type { ReactNode } from "react";
import { NavLink } from "react-router";

const LINKS = [
  { to: "/cms", label: "Library", end: true },
  { to: "/cms/import", label: "Import" },
  { to: "/cms/upload", label: "Upload" },
] as const;

/** The press-room nav under the catalog header; every /cms screen sits in it. */
export function CmsShell({ children }: { children: ReactNode }) {
  return (
    <div>
      <nav
        aria-label="Press room"
        className="bg-muted/40 border-b"
        data-cms-shell=""
      >
        <div className="mx-auto flex max-w-6xl items-center gap-6 px-4">
          <span className="catalog-label py-3">press room</span>
          {LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              end={"end" in link}
              className={({ isActive }) =>
                `-mb-px border-b-2 py-3 text-sm ${
                  isActive
                    ? "border-primary text-foreground font-medium"
                    : "text-muted-foreground hover:text-foreground border-transparent"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </div>
      </nav>
      <main className="mx-auto max-w-6xl px-4 py-8">{children}</main>
    </div>
  );
}

export function PageHeader({
  title,
  lede,
  actions,
}: {
  title: string;
  lede?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        <h1 className="font-serif text-3xl font-bold">{title}</h1>
        {lede && <p className="text-muted-foreground mt-1 text-sm">{lede}</p>}
      </div>
      {actions && <div className="flex gap-2">{actions}</div>}
    </div>
  );
}
